import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { CustomCategoryForSelectFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { CustomDetails } from 'modules/banking/components/AccountTransactionsDataTable/TransactionDetailSidePanel/CustomDetails'
import { CustomCategorySelector } from 'modules/finance/components/CustomCategorySelector'

export const Categorization = ({
  currentCategory,
  onChangeCategory,
}: {
  currentCategory: CustomCategoryForSelectFragment | null | undefined
  onChangeCategory: (newCategory?: CustomCategoryForSelectFragment | null) => void
}) => {
  return (
    <CustomDetails title={i18n.t('banking.transactions.detail.categorization_title')}>
      <Box gap="s8">
        <Text.Normal color="grey800">
          {i18n.t('banking.transactions.detail.categorization')}
        </Text.Normal>
        <Box>
          <CustomCategorySelector
            value={currentCategory}
            onSelect={onChangeCategory}
            width="full"
            minWidth="s400"
          />
        </Box>
      </Box>
    </CustomDetails>
  )
}
